import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EventqToastService } from './toast.service';

@Component({
  selector: 'eventq-toast-container',
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqToastContainer {
  private readonly toastService = inject(EventqToastService);

  readonly toasts = this.toastService.toasts;
  readonly position = this.toastService.position;
}
